import { Battery0Bar, Battery3Bar, Battery6Bar, BatteryFull } from '@mui/icons-material'
import { useTheme } from '@mui/material'

const BatteryIndicatorItem = ({ value }: { value: number }) => {
  const theme = useTheme()

  const { ariaLabel, iconColor, IconComponent } = {
    0: { ariaLabel: 'Empty battery', iconColor: theme.palette.error.main, IconComponent: Battery0Bar },
    1: { ariaLabel: 'Low battery', iconColor: theme.palette.warning.main, IconComponent: Battery3Bar },
    2: { ariaLabel: 'Medium battery', iconColor: theme.palette.success.main, IconComponent: Battery6Bar },
    3: { ariaLabel: 'Full battery', iconColor: theme.palette.success.main, IconComponent: BatteryFull },
  }[value] ?? { ariaLabel: 'Unknown', iconColor: theme.palette.text.primary, IconComponent: () => <>-</> }

  return <IconComponent htmlColor={iconColor} aria-label={ariaLabel} />
}

export default BatteryIndicatorItem
